import React from 'react';
import { Spinner } from 'react-bootstrap';

function LoadingSpinner() {
  return (
    <div
      data-html2canvas-ignore
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        width: '100%',
        height: '500px',
      }}
    >
      <Spinner animation="border" role="status" style={{ width: '64px', height: '64px', color: '#5cbfe6' }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default LoadingSpinner;
